<template>
  <div id="adminCrmSalesOrders">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">{{ admin }}</li>
      <li class="breadcrumb-item">{{ setting }}</li>
      <li class="breadcrumb-item active">
        <router-link :to="url">Ordini</router-link>
      </li>
    </ol>
    <div class="container-fluid card-title-admin">
      <h1>Ordini</h1>
    </div>
    <div class="container-fluid">
      <div class="card">
        <div class="tab-content">
          <div class="tab-pane active" id="tabTableSalesOrders" role="tabpanel" style="box-shadow: none;!important">
            <div class="row">
              <div class="col-sm-12">
                <bootstrapTable
                  :configurations="TableSalesOrderConfiguration"
                  :datas="tableData"
                  id="tableSalesOrders"
                  :onCheck="onTableCheckSalesOrders"
                  :onCheckAll="onTableCheckSalesOrders"
                  :onUncheck="onTableCheckSalesOrders"
                  :onUncheckAll="onTableCheckSalesOrders"
                  ref="tableSalesOrders"
                  :results="tableResult"
                ></bootstrapTable>
              </div>
            </div>
          </div>
     <!--Apre div id=tabDetailSalesOrders  -->
     <div  
            class="tab-pane nopadding"
            id="tabDetailSalesOrders"
            role="tabpanel"
          >
           <div
                v-for="SalesOrder in SalesOrder"
                v-bind:key="SalesOrder.id"
                >
            <div
                v-for="UsersDatas in UsersDatas"
                v-bind:key="UsersDatas.id"
                >
  
            <div class="card-body">
              <div class="row">
                <div class="col-10">
                <h2> Ordine {{ SalesOrder.id }} da {{UsersDatas.business_name}} ({{ UsersDatas.email }})</h2> 
                </div>
                <div class="col-2" style="text-align:right;">
                                  <button
                      type="button"
                      class="btn btn-danger"
                      data-dismiss="modal"
                      @click="confirmCancelSalesOrders"
                    ><i class="fa fa-chevron-left"></i>
                     INDIETRO
                    </button>
                      <button
                              type="button"
                              class="btn btn-success"
                              @click="confirmSendMailCustomer(SalesOrder.id)"
                            >
                                INVIA
                                </button>
                </div>
                </div></div>

             <!--   <div class="col-12">
                   <div class="row">
                   <div class="col-12">
                     <b style="font-size: 21px;">Anagrafica Utenti</b></div>
               </div></div>
            <div class="col-12">
                <div class="row">
                 <div class="col-3"> 
                    <label>Nome e Cognome</label><span class="col- col-form-label nopadding" :if="UsersDatas.name"><h6>{{ UsersDatas.name }}&nbsp;{{ UsersDatas.surname }}</h6></span> 
                  </div>
                  <div class="col-3">
                    <label>Indirizzo</label><span class="col- col-form-label nopadding" :if="UsersDatas.address"><h6>{{ UsersDatas.address }} {{ UsersDatas.postal_code }} {{ UsersDatas.country }} ({{ UsersDatas.province_id }})</h6></span>
                  </div> 
                    <div class="col-2">
                      <label>Telefono</label><br> <span class="col- col-form-label nopadding" :if="UsersDatas.telephone_number"><h6>{{ UsersDatas.telephone_number }}</h6></span>
                  </div> 
                  <div class="col-2">
                      <label>Codice Fiscale</label><br><span class="col- col-form-label nopadding" :if="UsersDatas.fiscal_code"><h6>{{ UsersDatas.fiscal_code }}</h6></span>
                  </div> 
                  <div class="col-2">
                      <label>Partita Iva</label><span class="col- col-form-label nopadding" :if="UsersDatas.vat_number"><h6>{{ UsersDatas.vat_number }}</h6></span>
                  </div></div>
                   </div></div>--->
                 <div class="col-12">
                   <div class="row">
                   <div class="col-8"> <b style="font-size: 21px;">Dettaglio Ordini</b></div>
                      <div class="col-4"> <b style="font-size: 21px;">Storico Ordini</b></div>
                 </div>
                    <div class="row">
                    <div class="col-4">
                    <div class="row">
                     <div class="col-4">
                       <label>Data</label>
                     <br />
                       <span
                                    class="col- col-form-label nopadding"
                                    :if="SalesOrder.date_order"
                                    ><h6>{{ SalesOrder.date_order }}</h6></span
                                  >
                     </div>
                     <div class="col-3">
                       <label>Totale</label>
                     <br />
                       <span
                                    class="col- col-form-label nopadding"
                                    :if="SalesOrder.total_amount"
                                    ><h6>&euro;&nbsp;{{ SalesOrder.total_amount }}</h6></span
                                  >
                     </div> 
                    
                     <div class="col-3">
                       <label>Prodotti</label>
                     <br />
                       <span
                                    class="col- col-form-label nopadding"
                                    :if="SalesOrder.total_quantity"
                                    ><h6>{{ SalesOrder.sum_quantity[0].total_quantity}}</h6></span
                                  >
                     </div>  
                   </div></div>  

                    <div class="col-4">
                    <div class="row">
                     <div class="col-6">
                       <label>Pagamento</label>
                     <br />
                       <span
                                    class="col- col-form-label nopadding"
                                    :if="SalesOrder.payment_type_id"
                                    ><h6>{{ SalesOrder.payment_type_id }}</h6></span
                                  >
                     </div>
                     <div class="col-4">
                       <label>Stato</label>
                     <br />
                      <span  class="col- col-form-label nopadding"
                      :if="SalesOrder.order_state_id"
                      ><h6>{{ SalesOrder.order_state_id }}</h6></span>                 
                     </div> 
                    <div class="col-2 row-sinistra">
                       <button
                          type="button"
                          class="btn btn-link"
                          @click="openPopupChangeStatus(rowIdSelected)">
                          <i class="fa fa-pencil"></i></button></div>

                   </div></div>
                  <div class="col-4">
                    <div class="row">
                      <div class="col-3">
                       <label>Nr.Ordini</label>
                     <br />
                       <span
                                    class="col- col-form-label nopadding"
                                    :if="SalesOrder.number_order"
                                    ><h6>{{ SalesOrder.number_order[0].num_id}}</h6></span
                                  >
                     </div>  

 <div class="col-3">
                       <label>Tot.Ordini</label>
                     <br />
                       <span
                                    class="col- col-form-label nopadding"
                                    :if="SalesOrder.sum_total_amount"
                                    ><h6>&euro;&nbsp;{{ SalesOrder.sum_total_amount}}</h6></span
                                  >
                     </div> 


                     <div class="col-3">
                       <label>Medio</label>
                     <br />
                       <span
                                    class="col- col-form-label nopadding"
                                    :if="SalesOrder.medium_amount"
                                    ><h6>&euro;&nbsp;{{ SalesOrder.medium_amount }}</h6></span>        
                      </div> 
                            <div class="col-3">
                            <label>Cliente dal</label>
                                                <br />
                                                  <span
                                    class="col- col-form-label nopadding"
                                    :if="UsersDatas.created_at"
                                    ><h6>{{ UsersDatas.created_at }}</h6></span
                                  > 
                          </div> 
                      </div>
                   </div>
                   </div>
                   </div>
                   
                       
                  <div style="font-size:16px; border-top: 1px dashed rgb(237, 237, 237); color:#515151;margin:0 0 0px 0;width:100%;"></div>
                               
                            <br />
                          </div>
                      </div>
                   </div><!-- chiusura div id=tabDetailSalesOrders  -->

      <div  
            class="tab-pane nopadding"
            style="box-shadow: none;"
            id="tabUserAddressessGoodsAndDocuments"
            role="tabpanel"
          >
                     <div class="row">
                       <div class="col-4"> 
                         <div class="row">
                       <div class="col-12"> 
                      <ul class="nav nav-tabs">
                      <li class="nav-item">
                       <button
                      id="tabAdminUserAddressesGoods"
                      class="nav-link active"
                      type="button"
                      data-toggle="tab"
                      href="#tabAdminUserAddressesGoods"
                      role="tab"
                      aria-controls="tabAdminUserAddressesGoods"
                      v-on:click="ontabAdminUserAddressesGoods"
                    >
                    <span>Spedizione Merce</span>
                    </button>
                    </li>
                    <li class="nav-item">
                  <button
                      id="tabAdminUserAddressesDocuments"
                      class="nav-link active"
                      type="button"
                      data-toggle="tab"
                      href="#tabAdminUserAddressesDocuments"
                      role="tab"
                      aria-controls="tabAdminUserAddressesDocuments"
                      v-on:click="ontabAdminUserAddressesDocuments"
                    >
                      <span>Spedizione Documenti</span>
                    </button>
                    </li>
                      </ul>
</div></div>  
        <div class="tab-content" style="border: 0px solid #c8ced3;">
                    <!-- tab Spedizione Merci  -->
                  <div class="card-body active tab-pane" id="UserAddressesGoods" role="tabpanel" style="padding-left: 25px;padding-right: 25px;box-shadow: none;">
                    <div
                        v-for="UserAddressesGoods in UserAddressesGoods"
                        v-bind:key="UserAddressesGoods.id"
                      >       
                                <div class="col-12">
                                
                                  <span
                                    class="col- col-form-label nopadding"
                                    :if="UserAddressesGoods.name"
                                    ><b>{{ UserAddressesGoods.name}}&nbsp;{{ UserAddressesGoods.surname}}</b>
                                  </span>
                                </div>
                                <div class="col-12">
                                 
                                  <span
                                    class="col- col-form-label nopadding"
                                    :if="UserAddressesGoods.address"
                                    ><b
                                      >{{ UserAddressesGoods.address }}<br />
                                      {{ UserAddressesGoods.postal_code }}
                                      &nbsp;{{ UserAddressesGoods.locality }}
                                      &nbsp;({{UserAddressesGoods.province_id}})
                                    </b>
                                  </span>
                                </div>
                                <div class="col-12">
                                  <span
                                    class="col- col-form-label nopadding"
                                    :if="UserAddressesGoods.phone_number"
                                    ><b>{{
                                      UserAddressesGoods.phone_number
                                    }}</b>
                                  </span>
                                </div>
                                  <div class="col-12">
                                  <span
                                    class="col- col-form-label nopadding"
                                    :if="UserAddressesGoods.vat_number"
                                    ><b>{{
                                      UserAddressesGoods.vat_number
                                    }}</b>
                                  </span>
                                </div>
                                  <div class="col-12">
                                  <span
                                    class="col- col-form-label nopadding"
                                    :if="UserAddressesGoods.fiscal_code"
                                    ><b>{{
                                      UserAddressesGoods.fiscal_code
                                    }}</b>
                                  </span>
                                </div>

                              </div></div>   
                <!-- end tab Spedizione Merci  -->

                    <!-- tab Spedizione Documenti  -->
    <div class="card-body tab-pane" id="UserAddressesDocuments" role="tabpanel" style="padding-left: 25px;padding-right: 25px;box-shadow: none;">
                        <div
                          v-for="UserAddressesDocuments in UserAddressesDocuments"
                          v-bind:key="UserAddressesDocuments.id"
                        >
                                <div class="col-12">
                                  <span
                                    class="col- col-form-label nopadding"
                                    :if="UserAddressesDocuments.name"
                                    ><b>{{UserAddressesDocuments.name}}&nbsp;{{UserAddressesDocuments.surname}}</b>
                                  </span>
                                </div>
                                <div class="col-12">
                                  <span
                                    class="col- col-form-label nopadding"
                                    :if="UserAddressesDocuments.address"
                                    ><b>{{ UserAddressesDocuments.address
                                      }}<br />
                                     {{ UserAddressesDocuments.postal_code }}
                                      &nbsp;{{ UserAddressesDocuments.locality }}
                                      &nbsp;({{UserAddressesDocuments.province_id}})
                                    </b>
                                  </span>
                                </div>
                                <div class="col-12">
                                  <span
                                    class="col- col-form-label nopadding"
                                    :if="
                                      UserAddressesDocuments.phone_number
                                    "
                                    ><b>{{
                                      UserAddressesDocuments.phone_number
                                    }}</b>
                                  </span>
                                </div>
                                  <div class="col-12">
                                  <span
                                    class="col- col-form-label nopadding"
                                    :if="
                                      UserAddressesDocuments.vat_number
                                    "
                                    ><b>{{
                                      UserAddressesDocuments.vat_number
                                    }}</b>
                                  </span>
                                </div>
                                  <div class="col-12">
                                  <span
                                    class="col- col-form-label nopadding"
                                    :if="
                                      UserAddressesDocuments.fiscal_code
                                    "
                                    ><b>{{
                                      UserAddressesDocuments.fiscal_code
                                    }}</b>
                                  </span>
                                </div>

                                </div>
                    </div></div>
        <!--end tab Spedizione Documenti  -->
                    </div>
                    <div class="col-8"> 
                      <ul class="nav nav-tabs" style="color: #2f353a;background: #fff; border-color: #eee;">
                       <li class="nav-item prodotti">
                  <button
                      style="color: #2f353a;background: #fff; border-color: #eee; border-bottom-color: #fff;"
                      id="tabAdminSalesOrderDetail"
                      class="nav-link active"
                      type="button"
                      data-toggle="tab"
                      href="#tabAdminSalesOrderDetail"
                      role="tab"
                      aria-controls="tabAdminSalesOrderDetail"
                      v-on:click="ontabAdminSalesOrderDetail"
                    >
                      <span>Prodotti</span>
                    </button>
                    </li></ul> 
          <!-- tab Prodotti  -->
        <div class="card-body tab-pane" id="SalesOrderDetail" role="tabpanel" style="padding-left: 25px;padding-right: 25px;box-shadow: none;">
            <div
            v-for="SalesOrderDetail in SalesOrderDetail"
            v-bind:key="SalesOrderDetail.id">
          <div class="row">    
          <div class="col-6">
                <div class="row no-gutters" style="margin-bottom: 15px;"> 
                  <div class="col-2">
                    <label>Codice</label>
                    <br>
                    <span
                      class="col- col-form-label nopadding"
                      :for="SalesOrderDetail.item_id">
                      <label>{{ SalesOrderDetail.item_id }}</label></span>
                    </div> 
                    <div class="col-7">
                      <label>Descrizione</label>
                      <br>
                      <span
                      class="col- col-form-label nopadding"
                      :for="SalesOrderDetail.description_language_item">
                      <label>{{ SalesOrderDetail.description_language_item }}<br>
                      Dimensioni: {{ SalesOrderDetail.width }} X {{ SalesOrderDetail.depth }} X {{ SalesOrderDetail.height }} mm <br>
                      Materiale: {{ SalesOrderDetail.support_id }}<br>
                      <div v-for="SalesOrderDetailOptional in SalesOrderDetailOptional" v-bind:key="SalesOrderDetailOptional.id"> 
                      {{ SalesOrderDetailOptional.title_tipology_optional }} : {{ SalesOrderDetailOptional.optional_id }}</div>
                      <a :href="SalesOrderDetail.file" target="_blank">Vedi File</a>
                        </label></span>
                      </div> 
                    <div class="col-2">
                      <label>Prezzo</label>
                    <input
                    class="form-control input-unit_price"
                    :id="'unit_price' + SalesOrderDetail.id"
                    :name="'unit_price' + SalesOrderDetail.id"
                    :value="SalesOrderDetail.unit_price"
                    >
                    </div>
                      <div class="col-1">
                    <label>Quantita'</label>
                      <input
                      style="width: 58px;"
                      class="form-control input-quantity"
                      :id="'quantity' + SalesOrderDetail.id"
                      :name="'quantity' + SalesOrderDetail.id"                                
                      :value="SalesOrderDetail.quantity"
                      />
                    </div> 
                  </div></div>
                    <div class="col-6">
                    <div class="row">  
                  <div class="col-2">
                    <label>Disp</label>
                    <br>
                    <span
                    class="col- col-form-label nopadding"
                    :for="SalesOrderDetail.available">
                    <label>{{ SalesOrderDetail.available }}</label></span
                    >
                    </div> 
                  <div class="col-2">
                    <label>Tot.Netto</label>
                    <br>
                  <span
                  class="col- col-form-label nopadding"
                  :for="SalesOrderDetail.net_amount">
                  <label>&euro;{{ SalesOrderDetail.net_amount }}</label></span
                  >
                  </div>
                    <div class="col-3">
                    <label>Tot.Iva</label>
                    <br>
                  <span
                  class="col- col-form-label nopadding"
                  :for="SalesOrderDetail.vat_amount">
                  <label>&euro;{{ SalesOrderDetail.vat_amount }}</label></span
                  >
                  </div>
                    <div class="col-3">
                    <label>Totale</label>
                    <br>
                  <span
                  class="col- col-form-label nopadding"
                  :for="SalesOrderDetail.total_amount">
                  <label>&euro;{{ SalesOrderDetail.total_amount }}</label></span
                  >
                  </div>
                    <div class="col-2 text-right">  
                      <button
                          type="button"
                          class="btn btn-success"
                          @click="confirmSaveOrderDetail(SalesOrderDetail.id)"><i class="fa fa-floppy-o"></i></button>
                          <button
                          type="button"
                          class="btn btn-danger"
                          data-dismiss="modal"
                          @click="confirmCancelOrderDetail(SalesOrderDetail.id)">
                          <i class="fa fa-trash"></i></button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> 
          <!-- end tab Prodotti  -->

      <!--   <table class="table" style="margin-bottom: 0rem!important; border-top:0px;">
                              <tr>
                                <th style="border-top: 0px solid #c8ced3;" scope="col-2">Codice</th>
                                <th style="border-top: 0px solid #c8ced3;" scope="col-2">Descrizione</th>
                               <th style="border-top: 0px solid #c8ced3;" scope="col-2">Prezzo</th>
                                <th style="border-top: 0px solid #c8ced3;" scope="col-2">Q.ta</th>
                                <th style="border-top: 0px solid #c8ced3;" scope="col-2">Disponibilità</th>
                                <th style="border-top: 0px solid #c8ced3;" scope="col-2">Totale Riga</th>
                                <th style="border-top: 0px solid #c8ced3;" scope="col"></th>
                              </tr>
                              </table>
                          <div
                            v-for="SalesOrderDetail in SalesOrderDetail"
                            v-bind:key="SalesOrderDetail.id"
                          >
                              <table class="table" style="margin-bottom: 0rem;border-top: 0px solid #c8ced3;">
                              <tr>
                                 
                                <td
                                 :for="SalesOrderDetail.item_id">
                                  <b>{{ SalesOrderDetail.item_id }}</b>
                                </td>
                                <td
                                  :for="
                                    SalesOrderDetail.description_language_item
                                  "
                                >
                                  <b>{{
                                    SalesOrderDetail.description_language_item
                                  }}</b>
                                </td>
                              <td>
                                <div class="row">
                                <input
                                style="width: 66px;"
                                  class="form-control input-unit_price"
                                  :id="'unit_price' + SalesOrderDetail.id"
                                  :name="'unit_price' + SalesOrderDetail.id"
                                  :value="SalesOrderDetail.unit_price"
                                /></div></td>
 <td style="border-top: 0px solid #c8ced3;">
                                <div class="row">
                                 <input
                                  style="width: 65px; margin-left: -20px;"
                                  class="form-control input-quantity"
                                  :id="'quantity' + SalesOrderDetail.id"
                                  :name="'quantity' + SalesOrderDetail.id"                                
                                  :value="SalesOrderDetail.quantity"
                                /></div></td>
                                  <td
                                  :for="SalesOrderDetail.available">
                                  <b style="">{{ SalesOrderDetail.available }}</b>
                                </td>
                                <td
                                :for="SalesOrderDetail.total_amount">
                                  <b>&euro;{{ SalesOrderDetail.total_amount }}</b>
                                </td>
                                <button
                              type="button"
                              class="btn btn-success"
                              @click="confirmSaveOrderDetail(SalesOrderDetail.id)"
                            >
                            <i class="fa fa-floppy-o"></i>                         
                            </button>
                            <button
                            style="margin-left: -71px;"
                              type="button"
                              class="btn btn-danger"
                              data-dismiss="modal"
                              @click="confirmCancelOrderDetail(SalesOrderDetail.id)"
                            >
                             <i class="fa fa-trash"></i>
                            </button>
                              </tr>
                            </table>
                              </div></div>  -->
                  <!-- end tab Prodotti  -->
                    </div>
                  </div></div>       
                  <br>
                  
                <!-- tab Spedizione  -->
                    <div class="card-body tab-pane" id="TrackingShipment" role="tabpanel" style="padding-left: 25px;padding-right: 25px; box-shadow: none;">
                        <div
                          v-for="SalesOrder in SalesOrder"
                          v-bind:key="SalesOrder.id"
                        >
                            <div class="row">
                            <div class="col-3">
                              <b style="font-size:21px;">Spedizione</b>
                              <div style="font-size:16px; border-top: 1px dashed rgb(237, 237, 237); color:#515151;margin:0 0 0px 0;width:187%;">
                              </div></div>
                              </div>
                              <br>
                              <div class="col-6">
                            <div class="row">
                            <div class="col-2">
                            <b>Corriere</b><br>
                              <span
                                class="col- col-form-label nopadding"
                                :if="SalesOrder.carrier_id"
                                ><label>{{ SalesOrder.carrier_id }}</label></span
                                  >
                              </div>
                              <div class="col-2">
                              <b>Peso</b><br>
                                <span
                                  class="col- col-form-label nopadding"
                                  :if="SalesOrderDetail.sum"
                                  ><label>{{ SalesOrderDetail[0].sum_total_weight }}</label></span
                                    >
                                </div>
                                <div class="col-2">
                                      <b>Costo</b><br>
                                        <span
                                          class="col- col-form-label nopadding"
                                          :if="SalesOrder.shipment_amount"
                                          ><label>&euro;&nbsp;{{ SalesOrder.shipment_amount }}</label></span
                                            >
                                        </div>     
                                        <div class="col-2">
                                      <b>Tracking</b><br>
                                      <input
                                        class="form-control input-quantity"
                                        :id="'tracking_shipment'"
                                        :name="'tracking_shipment'"                                
                                        :value="SalesOrder.tracking_shipment"
                                        v-on:keyup="ValueCompile"
                                      />
                                    </div> 
                                  <div class="col-4">
                                    <br>
                                    <button
                                    type="button"
                                    id="SaveTrackingShipment"
                                    class="btn btn-success"
                                    @click="confirmSaveTrackingShipment(SalesOrder.id)"
                                  ><i class="fa fa-floppy-o"></i>&nbsp;
                                      {{ save }}
                                      </button>

                                    <button
                                    type="button"
                                    id="SaveSendShipment"
                                    class="btn btn-success"
                                    @click="confirmSendTrackingShipment(SalesOrder.id)"
                                  ><i class="fa fa-floppy-o"></i>&nbsp;
                                      Salva/Invia
                                      </button></div>
                                      </div> 
                                    </div>
                                  </div>
                                </div>
                  <!-- end tab Spedizione  -->

                  <!-- tab Messaggi  -->
                  <div class="card-body tab-pane" id="TabMessages" role="tabpanel" style="padding-left: 25px;padding-right: 25px; box-shadow: none;">
                    <div
                          v-for="SalesOrder in SalesOrder"
                          v-bind:key="SalesOrder.id"
                        >
                          <br>
                           <div class="row"> 
                          <div class="col-4">
                                  <div class="col-12">
                                <b style="font-size:21px;">Messaggi</b><br>
                                <textarea
                                style="height: 100px;"
                                  class="form-control"
                                  :id="'messages'"
                                  :name="'messages'"
                                />
                                 <br>
                                <div class="" style="text-align:right;">
                                 <button
                              style="text-align:left;"
                              type="button"
                              id="SaveMessages"
                              class="btn btn-success"
                              @click="SaveMessages(SalesOrder.id, SalesOrder.user_id)"
                            ><i class="fa fa-floppy-o"></i>&nbsp;
                                {{ save }}
                                </button>
                                
                              <button
                              style="text-align:left;"
                              type="button"
                              id="SaveSendMessage"
                              class="btn btn-success"
                              @click="confirmSendMessage(SalesOrder.id, SalesOrder.user_id)"
                            ><i class="fa fa-floppy-o"></i>&nbsp;
                                Salva/Invia Messaggio
                                </button>
                              </div></div> 
                              <br>
                          <div class="col-12"> 
                          <div
                          v-for="OrderMessages in OrderMessages"
                          v-bind:key="OrderMessages.id"
                        >
                         <span
                                    class="col- col-form-label nopadding"
                                    :if="OrderMessages.created_at"
                                    ><strong>{{ OrderMessages.created_at }}</strong>&nbsp;&nbsp;<strong>{{ OrderMessages.id_sender }} ha scritto:</strong>
                                    <br><label>{{ OrderMessages.message }}</label>
                                    </span>        
                                </div>
                            </div>
                                </div> 

                              <div class="col-4">
                                  <div class="col-12">
                                <b style="font-size:21px;">Regole Applicate</b><br>
                                <div style="font-size:16px; border-top: 1px dashed rgb(237, 237, 237); color:#515151;margin:0 0 0px 0;width:70%;"></div>
                                  <span
                                    class="col- col-form-label nopadding"
                                    :if="CartRulesApplied.description"
                                    ><label>{{ CartRulesApplied[0].description }}</label>
                                    </span> 
                                  <br><br>
                                <b>Nota Interna</b><br>
                                <textarea
                                 style="height: 100px;"
                                  class="form-control"
                                  :id="'note'"
                                  :name="'note'"
                                  :value="SalesOrder.note"
                                />
                                <br>
                                <div class="" style="text-align:right;">
                                      <button
                                  style="text-align:left;"
                                  type="button"
                                  id="SaveNote"
                                  class="btn btn-success"
                                  @click="SaveNote(SalesOrder.id)"
                                ><i class="fa fa-floppy-o"></i>&nbsp;
                                {{ save }}
                                </button>
                                </div>
                             
                                </div>
                                </div>
                                    <div class="col-4" style="text-align: right;">
                                    <div class="col-6" style="text-align:right;"><b style="font-size:21px;">Totali</b><br></div>
                                   <div style="font-size:16px; border-top: 1px dashed rgb(237, 237, 237); color:#515151;margin:0 0 0px 0;width:46%;"></div>
                                     <div class="row">
                                    <div class="col-6 text-align: right;">
                                    <b>Imponibile:</b> <br>
                                    <b>Servizi:</b><br>
                                    <b>Spedizione:</b><br>
                                    <b>Pagamento:</b><br>
                                    <b>Imposta:</b>
                                    <br>
                                    <hr style="border-color: #fff;">
                                    <b>TOTALE:</b>
                                    </div>
                                    <div class="col-6" style="text-align: right;">
                                    <b> {{ SalesOrder.net_amount }}&nbsp;&euro;</b><br>
                                    <b>{{ SalesOrder.service_amount }}&nbsp;&euro;</b> <br>
                                    <b>{{ SalesOrder.shipment_amount }}&nbsp;&euro;</b> <br>
                                    <b>{{ SalesOrder.payment_cost }}&nbsp;&euro;</b><br>
                                    <b>{{ SalesOrder.vat_amount }}&nbsp;&euro;</b>
                                    <br>
                                    <hr>
                                    <b>{{ SalesOrder.total_amount }}&nbsp;&euro;</b>
                                    </div>
                                  </div>                            
                                </div>
                              </div>
                            </div>
                          </div>
                      <!-- end tab Messaggi  -->

                      <!--- popup change status order --->         
          <div class="modal" id="ChangeStatusOrder" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
              <div class="modal-content padding">
                <div class="modal-body mx-12">
                  <div class="md-form mb-12">
                    <div class="row">
                      <div class="col-6">
                       <span style="font-size: 18px">Cambio stato dell'ordine Nr. {{ DetailStatesOrder.id }} </span>
                      </div>
                    <div class="col-6">
                        <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      ><span aria-hidden="true">&times;</span>
                      </button>
                    </div></div>
                    <div class="row">
                      <div class="col-6">
                      <span style="font-size: 18px">Stato Attuale: {{ DetailStatesOrder.description_order }} </span>
                      </div></div>
                      <div class="row" style="padding:7px;">
                      <div class="col-6 nopadding">
                           <div class="form-check">
                          <label
                            class="switch switch-pill switch-primary"
                            style="margin: 2px; vertical-align: bottom"
                          >
                            <input
                              :id="'checksendemailstatesorders'"
                              type="checkbox"
                              name="checksendemailstatesorders"
                              checked="true"
                              class="switch-input checksendemailstatesorders"
                            />
                          <div class="switch-slider"></div> 
                          </label>&nbsp;&nbsp;
                            <span style="font-size: 18px">Invia e-mail al cliente</span><br>
                             <span style="font-size: 18px; margin-left:55px;" >({{ DetailStatesOrder.description_email_user }})</span>
                        </div>
                      </div>
                      <div class="col-6"> 
                        <span style="font-size: 18px">Imposta stato</span>
                        <select
                              class="custom-select select_order"
                              style="width: 100% !important"
                              id="select_order"
                              name="select_order"
                            ></select>
                      </div></div>
                  </div>
                   <div class="row">
                      <div class="col-12 text-right" style="padding: 20px;">
                        <button
                          type="button"
                          class="btn btn-success"
                          @click="confirmSaveChangeStatus(rowIdSelected)">Conferma</button>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          <!-- end popup change status order --> 


                     
                </div>
              </div>
            </div>
          </div>  
</template>
<script>
import BootstrapTable from "@/components/BootstrapTable.vue";
import PageDetail from "@/components/PageDetail.vue";
import Select2 from "@/components/Select2.vue";

export default {
  name: "adminCrmSalesOrders",
  components: {
    BootstrapTable,
    Select2,
    PageDetail
  },
  data: function() {
    return {
      add: dictionaryHelpers.getDictionary("Add"),
      language: dictionaryHelpers.getDictionary("Language"),
      admin: dictionaryHelpers.getDictionary("Admin"),
      cancel: dictionaryHelpers.getDictionary("Cancel"),
      setting: dictionaryHelpers.getDictionary("Setting"),
      del: dictionaryHelpers.getDictionary("Delete"),
      deleteCompleted: dictionaryHelpers.getDictionary("DeleteCompleted"),
      TableSalesOrderConfiguration: [],
      DetailSalesOrderConfiguration: [],
      detailSalesOrders: {},
      languages: 0,
      disableButton: true,
      insertCompleted: dictionaryHelpers.getDictionary("InsertCompleted"),
      newCategoryType: dictionaryHelpers.getDictionary("newCategoryType"),
      openDetail: dictionaryHelpers.getDictionary("OpenDetail"),
      save: dictionaryHelpers.getDictionary("Save"),
      defaultLanguageOptions: [],
      UsersDatas: [],
      SalesOrder: [],
      checkSendMail: false,
      UserAddressesGoods: [],
      UserAddressesDocuments: [],
      SalesOrderDetail: [],
      DetailStatesOrder: [],
      SalesOrderDetailOptional:[],
      SalesOrderDet: [],
      OrderMessages: [],
      CartRulesApplied: [],
      pageValueSelected: {
        id: 0,
        languagePageSetting: { content: null }
      },
      tableData: [],
      tableResult: [],
      
      titleDetail: null,
      updateCompleted: dictionaryHelpers.getDictionary("UpdateCompleted"),
      url: window.location.pathname,
      total_quantity:0,
      rowIdSelected: 0,
      rowsSelected: 0,
      rowIdSelectedPopup: 0
    };
  },
  created() {
    var adminCrmSalesOrders = this;
    spinnerHelpers.show();

    this.languages = storageData.sIdLanguage();

    adminCrmSalesOrders.defaultLanguageOptions = {
      id: storageData.sIdLanguage(),
      text: storageData.sDescriptionLanguage()
    };

    adminConfigurationServices.getFunctionality(function(result) {
      adminCrmSalesOrders.TableSalesOrderConfiguration =
        result.data.tablesConfigurations[0].tablesConfigurations;
      adminCrmSalesOrders.DetailSalesOrderConfiguration =
        result.data.tabsConfigurations[0].pageConfigurations;
      adminCrmSalesOrders.loadTable();
    });
  },
  methods: {
    loadTable(ln) {
      var adminCrmSalesOrders = this;
      if (!functionHelpers.isValued(ln)) {
        ln = storageData.sIdLanguage();
      } else {
        ln = this.languages;
      }

      salesOrderServices.getAllSalesOrder(ln, function(result) {
        adminCrmSalesOrders.tableData = result.data;   
      });
      spinnerHelpers.hide(); 
      $("#tabTableSalesOrders").addClass("active");
      $("#tabUserAddressessGoodsAndDocuments").removeClass("active");
      $("#UserAddressesGoods").removeClass("active");
      $("#UserAddressesDocuments").removeClass("active");
      $("#SalesOrderDetail").removeClass("active");
      $("#tabDetailSalesOrders").removeClass("active");
      $("#TrackingShipment").removeClass("active");
      $("#tabAdminSalesOrderDetail").removeClass("active");
      $("#TabMessages").removeClass("active");
      $("#ChangeStatusOrder").modal("hide");
    },

    languageChange(value) {
      spinnerHelpers.show();
      var adminCrmSalesOrders = this;
      this.languages = value;
      adminCrmSalesOrders.loadTable(value);
      spinnerHelpers.hide();
    },
    SalesOrderFormatter(value, row, index, field) {
      var adminCrmSalesOrders = this;
      var html =
        '<div class="container-fluid nopadding" style="width:80px;"><div class="row">';
      html +=
        '<div class="col-6"><button class="btn btn-success" onclick="adminCrmSalesOrders.__vue__.executeOpenDetail(' +
        row.code +
        ')"><i class="fa fa-pencil" title="' +
        this.openDetail +
        '" /></button></div>';
      html +=
        '<div class="col-6"><button class="btn btn-danger" onclick="adminCrmSalesOrders.__vue__.delete(' +
        row.code +
        ')"><i class="fa fa-trash"/></button></div>';

      if (functionHelpers.isValued(this.tableResult)) {
        $.each(this.tableResult, function(i, result) {
          if (result.code == row.code) {
            if (result.success) {
              html +=
                '<div class="col-1"><i class="fa fa-check text-success" title="';
              if (functionHelpers.isValued(result.message)) {
                html += result.message;
              } else {
                html += adminCrmSalesOrders.updateCompleted;
              }
              html += '" /></div>';
            } else {
              html +=
                '<div class="col-1"><i class="fa fa-exclamation-triangle text-danger" title="' +
                result.message +
                '" /></div>';
            }
            return;
          }
        });
      }
      html += "</div></div>";
      return html;
    },

  ChangeStatesOrderFormatter(value, row, index, field) {
    var adminCrmSalesOrders = this;
    var html ='<div class="container-fluid nopadding" style="width:80px;"><div class="row">';
      html +=
      '<button class="btn btn-link" onclick="adminCrmSalesOrders.__vue__.openPopupChangeStatus(' + row.code + ')"><i class="fa fa-pencil" title="' + this.openDetail + '" /></button>';
      return html;
    },

 ontabAdminSalesOrderDetail: function () {
var adminCrmSalesOrders = this;
      $("#SalesOrderDetail").addClass("active");
      $("#UserAddressesGoods").addClass("active");
      $("#UserAddressesDocuments").removeClass("active");
      $("#ChangeStatusOrder").modal("hide");
 },
 ontabAdminUserAddressesDocuments: function () {
      var adminCrmSalesOrders = this;
      $("#UserAddressesDocuments").addClass("active");
      $("#UserAddressesGoods").removeClass("active");
      $("#SalesOrderDetail").removeClass("active");
      $("#ChangeStatusOrder").modal("hide");

    },
 ontabAdminUserAddressesGoods: function () {
      var adminCrmSalesOrders = this;
      $("#UserAddressesGoods").addClass("active");
      $("#UserAddressesDocuments").removeClass("active");
      $("#SalesOrderDetail").removeClass("active");
      $("#ChangeStatusOrder").modal("hide");
    },

  openPopupChangeStatus: function (rowIdSelected){
   var adminCrmSalesOrders = this;
      $("#ChangeStatusOrder").modal("show");
adminCrmSalesOrders.rowIdSelectedPopup = rowIdSelected;
    var id = rowIdSelected;
      salesOrderServices.getDetailPopupSelect(id, function (response) {
        adminCrmSalesOrders.DetailStatesOrder = response.data[0].DetailStatesOrder[0];
      $.getScript("https://cdn.jsdelivr.net/npm/select2@4.1.0-beta.1/dist/js/select2.min.js").done(function () {
        var searchParam = "";
         var initials = [];
         if(response.data[0].DetailStatesOrder[0].select_order !=''){
           initials.push({
                id: response.data[0].DetailStatesOrder[0].select_order,
                text: response.data[0].DetailStatesOrder[0].description_order
              });
         }else{
           initials.push({
                id: '',
                text: '-'
              });
         }
          
        $("#select_order").select2({
          data: initials,
          ajax: {
            url: configData.wsRootServicesUrl + "/api/v1/documentStatuses/select",
            data: function (params) {
              if (params.term == "") {
                searchParam = "*";
              } else {
                searchParam = params.term;
              }
              var query = {
                search: searchParam,
              };
              return query;
            },
            processResults: function (data) {
              var dataParse = JSON.parse(data);
              return {
                results: dataParse.data,
              };
            },
          },
        });
      });
});
      $("#UserAddressesGoods").removeClass("active");
      $("#UserAddressesDocuments").removeClass("active");
      $("#SalesOrderDetail").removeClass("active");
  },

  confirmSaveChangeStatus:function (rowIdSelected) {
    var adminCrmSalesOrders = this;
    var idOrderPopup = 0;
      if(rowIdSelected>0){
        idOrderPopup = rowIdSelected;
      }else{
        idOrderPopup = adminCrmSalesOrders.rowIdSelectedPopup;
      }
      var checksendemailstatesorders = false;
      if ($("#checksendemailstatesorders").is(":checked")) {
        checksendemailstatesorders = true;
      } else {
        checksendemailstatesorders = false;
      }
    var data = {
      idOrder: idOrderPopup,
      select_order: $("#select_order").val(),
      checksendemailstatesorders:checksendemailstatesorders,
    };
       salesOrderServices.saveChangeStatus(data, function (result) {
        salesOrderServices.getBySalesOrder(idOrderPopup, function(result) {
            if(adminCrmSalesOrders.rowIdSelected >0){
              adminCrmSalesOrders.SalesOrder = result.data;
            }
        });
        salesOrderServices.getDetailPopupSelect(idOrderPopup, function (response) {
          adminCrmSalesOrders.DetailStatesOrder = response.data[0].DetailStatesOrder[0];
           notificationHelpers.success("Aggiornamento eseguito");
        }); 
      });  
  },

    delete(id) {
      var adminCrmSalesOrders = this;
      spinnerHelpers.show();
      salesOrderServices.del(id, function() {
        notificationHelpers.success(
          dictionaryHelpers.getDictionary("DeleteCompleted")
        );

        var ln =
          adminCrmSalesOrders.pageValueSelected.languagePageSetting.idLanguage;
        if (!functionHelpers.isValued(ln)) {
          ln = storageData.sIdLanguage();
        }
        adminCrmSalesOrders.loadTable(ln);
        window.scrollTo(0, 0);
      });
    },

    executeOpenDetail(id) {

      spinnerHelpers.show();
      var adminCrmSalesOrders = this;
      this.rowIdSelected = id;
      this.titleDetail = this.customer;

      $.each(this.tableData, function(i, row) {
        if (adminCrmSalesOrders.rowIdSelected == row.code) {
          adminCrmSalesOrders.detailSalesOrders = row;
        }
      });

      salesOrderServices.getBySalesOrder(adminCrmSalesOrders.rowIdSelected, function(result) {
          adminCrmSalesOrders.SalesOrder = result.data;
          adminCrmSalesOrders.UsersDatas = result.data[0].UsersDatas;
          adminCrmSalesOrders.UserAddressesGoods = result.data[0].UserAddressesGoods;
          adminCrmSalesOrders.UserAddressesDocuments = result.data[0].UserAddressesDocuments;
          adminCrmSalesOrders.SalesOrderDetail = result.data[0].SalesOrderDetail;
          adminCrmSalesOrders.SalesOrderDet = result.data[0].SalesOrderDet;
          adminCrmSalesOrders.OrderMessages = result.data[0].OrderMessages;
          adminCrmSalesOrders.CartRulesApplied = result.data[0].CartRulesApplied;
          adminCrmSalesOrders.SalesOrderDetailOptional = result.data[0].SalesOrderDetailOptional;
          adminCrmSalesOrders.SalesOrderDetailTitleTipology_Optional = result.data[0].SalesOrderDetailTitleTipology_Optional;
          adminCrmSalesOrders.ValueCompile();
          spinnerHelpers.hide();
        });
      $("#tabDetailSalesOrders").addClass("active");
      $("#UserAddressesGoods").addClass("active");
      $("#TrackingShipment").addClass("active");  
      $("#tabUserAddressessGoodsAndDocuments").addClass("active");
      $("#tabTableSalesOrders").removeClass("active");
      $("#UserAddressesDocuments").removeClass("active");
      $("#ChangeStatusOrder").modal("hide");
      $("#SalesOrderDetail").addClass("active");
      $("#tabAdminSalesOrderDetail").addClass("active");
      $("#SalesOrderDetail").addClass("active");
      $("#TabMessages").addClass("active");
      spinnerHelpers.hide();
    },
    
    confirmSaveSalesOrders() {
      if (confirm(dictionaryHelpers.getDictionary("ConfirmSave"))) {
        this.executeSaveSalesOrders();
      }
    },


    confirmSaveOrderDetail(id){
    var adminCrmSalesOrders = this;
    var data = {
    idOrder: id,
    quantity: $("#quantity" + id).val(),
    unit_price: $("#unit_price" + id).val(),
    };
       salesOrderServices.updateSalesOrderDetail(data, function (result) {
        //adminCrmSalesOrders.getBySalesOrder();
        notificationHelpers.success("Modifica eseguita");
      });
    },

    ValueCompile(){
    setTimeout(function(
    ){ 
if ($("#tracking_shipment").val() == "" || $("#tracking_shipment").val() == undefined) {
      $("#SaveSendShipment").hide(); 
      }else{  
      $("#SaveSendShipment").show();     
      } 
   }, 1000);
 
    },

  confirmSendTrackingShipment(id) {
    var adminCrmSalesOrders = this;
      var data = {
            id: id,
            tracking_shipment: $("#tracking_shipment").val(),
          };

          salesOrderServices.SendShipment(data, function (result) {
            notificationHelpers.success("Email inviata");
          });
        },


confirmSendMessage(id,user_id) {
    var adminCrmSalesOrders = this;
      var data = {
          id: id,
          sUserId: storageData.sUserId(),
          messages: $("#messages").val(),
          user_id: user_id,
          };
            salesOrderServices.insertAndSendMessages(data, function (result) {
        notificationHelpers.success("Messaggio Inserito/Inviato con Successo!");
          });
        },


 /*onChangeCheckSend(id,tracking_shipment) {
      var adminCrmSalesOrders = this;

      if (adminCrmSalesOrders.checkSendMail) {
        adminCrmSalesOrders.checkSendMail = false;
      }else{
        adminCrmSalesOrders.checkSendMail = true;
      }
      var data = {
        id: id,
        check_send: check_send, 
        tracking_shipment: tracking_shipment,
        checkSendMail: adminCrmSalesOrders.checkSendMail,
      };

      salesOrderServices.updateTrackingShipment(data, function (result) {
        notificationHelpers.success("Email inviata");
      });
    },*/

SaveMessages(id,user_id){
 var adminCrmSalesOrders = this;
  var data = {
    id: id,
    sUserId: storageData.sUserId(),
    messages: $("#messages").val(),
    user_id: user_id,
    };
       salesOrderServices.insertMessages(data, function (result) {
        notificationHelpers.success("Messaggio Inserito con Successo!");
      });
 }, 

  SaveNote(id){
  var adminCrmSalesOrders = this;
    var data = {
      id: id,
      sUserId: storageData.sUserId(),
      note: $("#note").val(),
      };
        salesOrderServices.updateNote(data, function (result) {
          notificationHelpers.success("Nota Modificata con Successo!");
        });
  }, 

  confirmSaveTrackingShipment(id){
  var adminCrmSalesOrders = this;
  var check_send = false;
 
  if ($("#check_send").is(":checked")) {
      check_send = true;
    } else {
      check_send = false;
    }

    var data = {
    id: id,
    tracking_shipment: $("#tracking_shipment").val(),
    check_send: check_send,  
    };
       salesOrderServices.updateTrackingShipment(data, function (result) {
        //adminCrmSalesOrders.getBySalesOrder();
        notificationHelpers.success("Modifica eseguita");
      });
    },

confirmSendMailCustomer(id){
 var adminCrmSalesOrders = this;
 var data = {
    id: id,
    };
       salesOrderServices.SendMailCustomer(data, function (result) {
        notificationHelpers.success("Email Inviata");
      });
    },


confirmCancelOrderDetail(id) {
      var adminCrmSalesOrders = this;
      if (
        confirm("Sei sicuro di voler eliminare il prodotto dall'ordine?")
      ) {
      
          salesOrderServices.deleteOrderDetail(id, function (result) {
           // adminCrmSalesOrders.getBySalesOrder();
            notificationHelpers.success("Eliminazione avvenuta correttamente");
          });
     }
 },  

    executeSaveSalesOrders() {
      spinnerHelpers.show();
      var adminCrmSalesOrders = this;
      this.rowsSelected = 0;
      this.tableResult = [];

      $.each(this.$refs.tableSalesOrders.getRowSelected(), function(i, row) {
        var rowToSave = row;
        rowToSave.idFunctionality = menuHelpers.getIdFunctionByAdminUrl();
        adminCrmSalesOrders.rowsSelected = adminCrmSalesOrders.rowsSelected + 1;

        salesOrderServices.update(
          rowToSave,
          function() {
            adminCrmSalesOrders.checkAllIsSaved();
            adminCrmSalesOrders.tableResult.push({
              id: rowToSave.id,
              success: true
            });
            notificationHelpers.success(adminCrmSalesOrders.updateCompleted);
          },
          function(response) {
            adminCrmSalesOrders.checkAllIsSaved();
            adminCrmSalesOrders.tableResult.push({
              id: rowToSave.id,
              success: false,
              message: response
            });
            notificationHelpers.error(response);
          }
        );
      });
    },

    onTableCheckSalesOrders() {
      var countRowSelected = this.$refs.tableSalesOrders.countRowSelected();
      if (countRowSelected == 0) {
        this.disableButton = true;
      } else {
        this.disableButton = false;
      }
    },

    confirmCancelSalesOrders() {
      if (confirm(dictionaryHelpers.getDictionary("ConfirmCancel"))) {
        this.executeCancelDocumentsStatuses();
      }
    },

    executeCancelDocumentsStatuses() {
      spinnerHelpers.show();
      this.detailTemplateEditorData = {};
      $("#tabTableSalesOrders").addClass("active");
      $("#tabDetailSalesOrders").removeClass("active");
      $("#tabUserAddressessGoodsAndDocuments").removeClass("active");
      $("#UserAddressesGoods").removeClass("active");
      $("#UserAddressesDocuments").removeClass("active");
      $("#SalesOrderDetail").removeClass("active");
      $("#tabUserAddressessGoodsAndDocuments").removeClass("active");
      $("#TrackingShipment").removeClass("active");
      $("#tabAdminSalesOrderDetail").removeClass("active");
      $("#SalesOrderDetail").removeClass("active");
      $("#TabMessages").removeClass("active");
      $("#ChangeStatusOrder").modal("hide");
      spinnerHelpers.hide();
    },

    confirmSaveSalesOrders() {
      if (confirm(dictionaryHelpers.getDictionary("ConfirmSave"))) {
        this.executeSaveSalesOrders();
      }
    },

    executeSaveSalesOrders() {
      spinnerHelpers.show();
      var adminCrmSalesOrders = this;
      this.detailSalesOrders.idFunctionality = menuHelpers.getIdFunctionByAdminUrl();

      if (!functionHelpers.isValued(this.detailSalesOrders.code)) {
        this.detailSalesOrders.code = false;
      }

      if (!functionHelpers.isValued(this.detailSalesOrders.description)) {
        this.detailSalesOrders.description = false;
      }

      if (!functionHelpers.isValued(this.languages)) {
        this.detailSalesOrders.idLanguage = storageData.sIdLanguage();
      } else {
        this.detailSalesOrders.idLanguage = this.languages;
      }

      if (
        functionHelpers.isValued(this.rowIdSelected) &&
        this.rowIdSelected > 0) {
        this.detailSalesOrders.id = this.rowIdSelected;
        salesOrderServices.update(this.detailSalesOrders, function(result) {
          adminCrmSalesOrders.tableResult.push({
            id: result.data,
            success: true,
            message: adminCrmSalesOrders.updateCompleted
          });
          notificationHelpers.success(adminCrmSalesOrders.updateCompleted);
          adminCrmSalesOrders.loadTable(adminCrmSalesOrders.languages);
          $("#tabTableSalesOrders").addClass("active");
          $("#tabDetailSalesOrders").removeClass("active");
          $("#tabUserAddressessGoodsAndDocuments").removeClass("active");
          $("#UserAddressesGoods").removeClass("active");
          $("#UserAddressesDocuments").removeClass("active");
          $("#SalesOrderDetail").removeClass("active");
          $("#tabUserAddressessGoodsAndDocuments").removeClass("active");
          $("#TrackingShipment").removeClass("active");
          $("#tabAdminSalesOrderDetail").removeClass("active");
          $("#SalesOrderDetail").removeClass("active");
          $("#TabMessages").removeClass("active");
          $("#ChangeStatusOrder").modal("hide");
        });
      } else {
        salesOrderServices.insert(this.detailSalesOrders, function(result) {
          adminCrmSalesOrders.tableResult.push({
            id: result.data,
            success: true,
            message: adminCrmSalesOrders.insertCompleted
          });
          notificationHelpers.success(adminCrmSalesOrders.insertCompleted);
          adminCrmSalesOrders.loadTable(adminCrmSalesOrders.languages);
          $("#tabTableSalesOrders").addClass("active");
          $("#tabDetailSalesOrders").removeClass("active");
          $("#tabUserAddressessGoodsAndDocuments").removeClass("active");
          $("#UserAddressesGoods").removeClass("active");
          $("#UserAddressesDocuments").removeClass("active");
          $("#SalesOrderDetail").removeClass("active");
          $("#tabUserAddressessGoodsAndDocuments").removeClass("active");
          $("#TrackingShipment").removeClass("active");
          $("#tabAdminSalesOrderDetail").removeClass("active");
          $("#SalesOrderDetail").removeClass("active");
          $("#TabMessages").removeClass("active");
          $("#ChangeStatusOrder").modal("hide");
        });
      }
    },

    checkAllIsSaved() {
      this.rowsSelected = this.rowsSelected - 1;
      if (this.rowsSelected == 0) {
        this.disableButton = true;
        this.loadTable(this.languages);
      }
    }
  }
};
</script>

<style scoped>
.card-title-admin .card {
  background: transparent;
  border: 0px;
}
.card-title-admin h1 {
  font-size: 40px;
  font-weight: lighter;
  color: #303c54;
}
.align-btn {
  position: absolute;
  margin-top: 10px;
  z-index: 1;
}
#tabDetailSalesOrders{
  box-shadow: none;
 } 

 div.row-sinistra {
  float: left;
  width: 50%;
  box-sizing: border-box;

}
div.row-sinistra {
  border-right: 2px dashed rgb(237, 237, 237);
  padding-right: 8px;
  font-size:16px;
  color:#515151;
}
.nav-tabs .nav-link.active {
    color: #2f353a;
    background: #fff;
    border-color: #eee;
    border-bottom-color: #fff;
}
.nav-tabs {
    border-bottom: 1px solid #eee;
}
.prodotti {
  width:100%!important;
}

</style>

